import { useMemo } from 'react';
import { CALENDAR_STATUS_LABELS, type CalendarColorPalette } from 'dashboard409a/common/constants/calendar';
import { ColorSelector, ColorSelectorConfig } from 'dashboard409a/components/ColorSelector';
import { CalendarPreview } from 'dashboard409a/components/ColorSelector/CalendarPreview';
import { useColorPalette } from 'dashboard409a/hooks/useColorPalette';
import { ModelStatus } from 'dashboard409a/pages/Workboard/common/types';
import { toSolidColor } from 'dashboard409a/utilities/colorPalette';

const CalendarPreviewWrapper = ({ colorPalette }: { colorPalette: CalendarColorPalette }) => (
  <CalendarPreview colorPalette={colorPalette} />
);

function renderModelsColorSelectorPreview(palette: CalendarColorPalette) {
  return <CalendarPreviewWrapper colorPalette={palette} />;
}

const getModelStatusPaletteKeys = (): Array<keyof CalendarColorPalette> =>
  Object.keys(ModelStatus).filter(
    key => Number.isNaN(Number(key))
  ) as Array<keyof CalendarColorPalette>;

interface ModelsColorSelectorProps {
  onClose?: () => void;
  hideTrigger?: boolean;
  modalOpen?: boolean;
  onModalOpenChange?: (open: boolean) => void;
}

const ModelsColorSelector = ({
  onClose,
  hideTrigger,
  modalOpen,
  onModalOpenChange,
}: ModelsColorSelectorProps = {}) => {
  const config: ColorSelectorConfig<CalendarColorPalette> = useMemo(
    () => ({
      title: 'Calendar Color Palette',
      tooltip: 'Change Calendar Colors',
      useHook: useColorPalette,
      statusLabels: CALENDAR_STATUS_LABELS,
      sections: [
        {
          title: 'Model Status Colors',
          keys: getModelStatusPaletteKeys(),
        },
        {
          title: 'Calendar Style Colors',
          keys: ['BACKGROUND', 'BORDER', 'LABELS', 'WAITING'] as Array<keyof CalendarColorPalette>,
        },
      ],
      modalWidth: '500px',
      showPreview: true,
      previewComponent: renderModelsColorSelectorPreview,
      toSolidColor,
      onClose,
      hideTrigger,
      modalOpen,
      onModalOpenChange,
    }),
    [onClose, hideTrigger, modalOpen, onModalOpenChange]
  );

  return <ColorSelector config={config} />;
};

export default ModelsColorSelector;
